import graphql from "babel-plugin-relay/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { useFragment } from "react-relay";

import { setRateIdOnRoundAtom } from "@/screens/JoinBooking/ConfirmPanel/atoms/actions/setRateIdOnRoundAtom/setRateIdOnRoundAtom";
import { getRateOnRoundAtom } from "@/screens/JoinBooking/ConfirmPanel/atoms/selectors/getRateOnRoundAtom/getRateOnRoundAtom";
import { selectedRoundAtom } from "@/screens/JoinBooking/ConfirmPanel/atoms/stores";
import { DropdownSelect } from "@whoosh/design-system/src/components/controls";
import { VStack } from "@whoosh/design-system/src/components/primitive";

import { useGetActivityManagementPlayerRateOptions } from "../../hooks/useGetActivityManagementPlayerRateOptions/useGetActivityManagementPlayerRateOptions";
import { ConfigureActivityManagementRoundPlayerRate_Booking$key } from "./__generated__/ConfigureActivityManagementRoundPlayerRate_Booking.graphql";

export const ConfigureActivityManagementRoundPlayerRate = ({
  bookingRef,
}: {
  bookingRef: ConfigureActivityManagementRoundPlayerRate_Booking$key | null;
}) => {
  const booking = useFragment(
    ConfigureRoundGolfPlayerRateControlFragmentString,
    bookingRef
  );
  const currentRate = useAtomValue(getRateOnRoundAtom);
  const currentRateId = currentRate?.id;
  const setRateIdOnRound = useSetAtom(setRateIdOnRoundAtom);
  const selectedRound = useAtomValue(selectedRoundAtom);
  const isCurrentRateLocked = currentRate?.isLocked ?? false;
  const dropdownOptions = useGetActivityManagementPlayerRateOptions({
    bookingRef: booking ?? null,
    round: selectedRound,
  });

  return dropdownOptions.length > 0 ? (
    <VStack flex={1}>
      <DropdownSelect
        hideOuterMargin
        isViewOnly={isCurrentRateLocked}
        hideChevron
        includeLeftElementInSelectedValue
        contentSizeOverride="regular"
        options={dropdownOptions}
        value={currentRateId}
        onChange={(rateId) => {
          setRateIdOnRound({
            rateId,
          });
        }}
      />
    </VStack>
  ) : null;
};

const ConfigureRoundGolfPlayerRateControlFragmentString = graphql`
  fragment ConfigureActivityManagementRoundPlayerRate_Booking on Booking {
    ...useGetActivityManagementPlayerRateOptions_Booking
  }
`;
